<div id="deviceIOCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@deviceio_title">I/O dispositivo</ng-container>
    <fa-icon *ngIf="userCanDeviceEdit" icon="edit" class="float-right margin-right-20 icon-clickable"
      (click)="modifyIOs()"></fa-icon>
  </div>

  <div class="control-card-content">
    <div class="scrollable-wrapper">
      <div class="table-container">


        <table mat-table matSort #iotable class="simple-table">

          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef i18n="@@deviceio_number">Numero</th>
            <td mat-cell *matCellDef="let element"> {{ element.number }} </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef i18n="@@deviceio_type">Tipo</th>
            <td mat-cell *matCellDef="let element"> {{ element.typeString }} </td>
          </ng-container>

          <ng-container matColumnDef="mode">
            <th mat-header-cell *matHeaderCellDef i18n="@@deviceio_mode">Modo</th>
            <td mat-cell *matCellDef="let element"> {{ element.mode }} </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef i18n="@@deviceio_name">Nome</th>
            <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
            [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
          </tr>

        </table>

      </div>
    </div>
  </div>

  <app-loading-screen #ioloader></app-loading-screen>

</div>